import { render } from "./articlePub.vue?vue&type=template&id=ceaa9502"
import script from "./articlePub.vue?vue&type=script&lang=js"
export * from "./articlePub.vue?vue&type=script&lang=js"

import "./articlePub.vue?vue&type=style&index=0&id=ceaa9502&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__